export class DomSelector {
	private resolve: (e: Element) => void;

	private currentSelection: Element;
	private previousStyle: string;

	constructor(public getElement?: (element: Element, e: JQuery.MouseEventBase) => Element) {
		if (this.getElement == null) {
			this.getElement = (elem) => elem;
		}
	}

	public color: string = "blue";

	public runAsync(): Promise<Element> {
		setImmediate(() => this.start());
		return new Promise((resolve, reject) => {
			this.resolve = resolve;
		});
	}

	public cancel() {
		this.end(null);
	}

	private start() {
		$(document)
			.on("click", this.onClick)
			.on("mousemove", this.onMouseMove)
			.on("keyup", this.onKeyUp);

		$(document.body.parentElement)
			.css({ border: "3px solid red" });
	}

	private end(element: Element) {
		$(document)
			.off("click", this.onClick)
			.off("mousemove", this.onMouseMove)
			.off("keyup", this.onKeyUp);

		$(document.body.parentElement)
			.removeAttr("style");

		this.removeSelection();
		this.resolve(element);
	}

	private onClick = (e: JQuery.ClickEvent) => {
		let element = this.getElement(e.target, e);
		if (element) {
			this.end(element);
		}

		return false;
	}

	private onMouseMove = (e: JQuery.MouseMoveEvent) => {
		this.removeSelection();
		this.updateSelection(this.getElement(e.target, e));

		return false;
	}

	private onKeyUp = (e: JQuery.KeyUpEvent) => {
		const BACKSPACE = 8;
		const ESC = 27;
		const DELETE = 46;

		if (e.keyCode === BACKSPACE || e.keyCode === ESC || e.keyCode === DELETE) {
			this.cancel();
		}

		return false;
	}

	private removeSelection() {
		if (this.currentSelection) {
			$(this.currentSelection).attr("style", this.previousStyle);
		}

		this.currentSelection = null;
		this.previousStyle = null;
	}

	private updateSelection(newSelection: Element) {
		this.currentSelection = newSelection;
		if (newSelection) {
			let elem = $(this.currentSelection);
			this.previousStyle = elem.attr("style") || "";
			elem.css({ outline: "2px solid " + this.color });
		}
	}
}